"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchArtifact = exports.downloadGraalVMEE = void 0;
const c = __importStar(require("./constants"));
const core = __importStar(require("@actions/core"));
const fs = __importStar(require("fs"));
const httpClient = __importStar(require("@actions/http-client"));
const io = __importStar(require("@actions/io"));
const path = __importStar(require("path"));
const stream = __importStar(require("stream"));
const util = __importStar(require("util"));
const retry_helper_1 = require("@actions/tool-cache/lib/retry-helper");
const utils_1 = require("./utils");
const assert_1 = require("assert");
const v4_1 = __importDefault(require("uuid/v4"));
function downloadGraalVMEE(gdsToken, version, javaVersion) {
    return __awaiter(this, void 0, void 0, function* () {
        const userAgent = `GraalVMGitHubAction/1.0.4 (arch:${c.GRAALVM_ARCH}; os:${c.GRAALVM_PLATFORM}; java:${javaVersion})`;
        const baseArtifact = yield fetchArtifact(userAgent, 'isBase:True', version, javaVersion);
        return downloadArtifact(gdsToken, userAgent, baseArtifact);
    });
}
exports.downloadGraalVMEE = downloadGraalVMEE;
function fetchArtifact(userAgent, metadata, version, javaVersion) {
    return __awaiter(this, void 0, void 0, function* () {
        const http = new httpClient.HttpClient(userAgent);
        let filter;
        if (version === c.VERSION_LATEST) {
            filter = `sortBy=timeCreated&limit=1`; // latest and only one item
        }
        else {
            filter = `metadata=version:${version}`;
        }
        const response = yield http.get(`${c.GDS_BASE}/artifacts?productId=${c.GDS_GRAALVM_PRODUCT_ID}&${filter}&metadata=java:jdk${javaVersion}&metadata=os:${c.GRAALVM_PLATFORM}&metadata=arch:${c.GRAALVM_ARCH}&metadata=${metadata}&status=PUBLISHED&responseFields=id&responseFields=checksum`, { accept: 'application/json' });
        if (response.message.statusCode !== 200) {
            throw new Error(`Unable to find JDK${javaVersion}-based GraalVM EE ${version}`);
        }
        const artifactResponse = JSON.parse(yield response.readBody());
        if (artifactResponse.items.length !== 1) {
            throw new Error(`Found more than one GDS artifact`);
        }
        return artifactResponse.items[0];
    });
}
exports.fetchArtifact = fetchArtifact;
function downloadArtifact(gdsToken, userAgent, artifact) {
    return __awaiter(this, void 0, void 0, function* () {
        let downloadPath;
        try {
            downloadPath = yield downloadTool(`${c.GDS_BASE}/artifacts/${artifact.id}/content`, userAgent, {
                accept: 'application/x-yaml',
                'x-download-token': gdsToken
            });
        }
        catch (err) {
            if (err instanceof HTTPError && err.httpStatusCode) {
                if (err.httpStatusCode === 401) {
                    throw new Error(`The provided "gds-token" was rejected (reason: "${err.gdsError.message}", opc-request-id: ${err.headers['opc-request-id']})`);
                }
            }
            throw err;
        }
        const sha256 = (0, utils_1.calculateSHA256)(downloadPath);
        if (sha256.toLowerCase() !== artifact.checksum.toLowerCase()) {
            throw new Error(`Checksum does not match (expected: "${artifact.checksum}", got: "${sha256}")`);
        }
        return downloadPath;
    });
}
/**
 * Simplified fork of tool-cache's downloadTool [1] with the ability to set a custom user agent.
 * [1] https://github.com/actions/toolkit/blob/2f164000dcd42fb08287824a3bc3030dbed33687/packages/tool-cache/src/tool-cache.ts
 */
class HTTPError extends Error {
    constructor(httpStatusCode, gdsError, headers) {
        super(`Unexpected HTTP response: ${httpStatusCode}`);
        this.httpStatusCode = httpStatusCode;
        this.gdsError = gdsError;
        this.headers = headers;
        Object.setPrototypeOf(this, new.target.prototype);
    }
}
function downloadTool(url, userAgent, headers) {
    return __awaiter(this, void 0, void 0, function* () {
        const dest = path.join(getTempDirectory(), (0, v4_1.default)());
        yield io.mkdirP(path.dirname(dest));
        core.debug(`Downloading ${url}`);
        core.debug(`Destination ${dest}`);
        const maxAttempts = 3;
        const minSeconds = 10;
        const maxSeconds = 20;
        const retryHelper = new retry_helper_1.RetryHelper(maxAttempts, minSeconds, maxSeconds);
        return yield retryHelper.execute(() => __awaiter(this, void 0, void 0, function* () {
            return yield downloadToolAttempt(url, userAgent, dest || '', headers);
        }), (err) => {
            if (err instanceof HTTPError && err.httpStatusCode) {
                // Don't retry anything less than 500, except 408 Request Timeout and 429 Too Many Requests
                if (err.httpStatusCode < 500 &&
                    err.httpStatusCode !== 408 &&
                    err.httpStatusCode !== 429) {
                    return false;
                }
            }
            // Otherwise retry
            return true;
        });
    });
}
function downloadToolAttempt(url, userAgent, dest, headers) {
    return __awaiter(this, void 0, void 0, function* () {
        if (fs.existsSync(dest)) {
            throw new Error(`Destination file path ${dest} already exists`);
        }
        // Get the response headers
        const http = new httpClient.HttpClient(userAgent, [], {
            allowRetries: false
        });
        const response = yield http.get(url, headers);
        if (response.message.statusCode !== 200) {
            const errorResponse = JSON.parse(yield response.readBody());
            const err = new HTTPError(response.message.statusCode, errorResponse, response.message.headers);
            core.debug(`Failed to download from "${url}". Code(${response.message.statusCode}) Message(${response.message.statusMessage})`);
            throw err;
        }
        // Download the response body
        const pipeline = util.promisify(stream.pipeline);
        let succeeded = false;
        try {
            yield pipeline(response.message, fs.createWriteStream(dest));
            core.debug('Download complete');
            succeeded = true;
            return dest;
        }
        finally {
            // Error, delete dest before retry
            if (!succeeded) {
                core.debug('Download failed');
                try {
                    yield io.rmRF(dest);
                }
                catch (err) {
                    core.debug(`Failed to delete '${dest}'. ${err}`);
                }
            }
        }
    });
}
function getTempDirectory() {
    const tempDirectory = process.env['RUNNER_TEMP'] || '';
    (0, assert_1.ok)(tempDirectory, 'Expected RUNNER_TEMP to be defined');
    return tempDirectory;
}
